import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike } from "../../../../../db/models/decontamination/order";
import { OrderItemLike } from "../../../../../db/models/decontamination/orderItem";
import { OrderItemDetailViewData } from "../../detail/index";
import { SelectOptionData } from "../../../../../../core/view/data-bind/types/selectbox-base";
import ConfirmModal from "../../../../../../core/modals/confirm/index";
import { ModalResultType, ModalColor } from "../../../../../../core/modal/index";
import { ClientAction } from "../../../../../synchronizer/index";
import ErrorModal from "../../../../../../core/modals/error/index";
import MessageModal from "../../../../../../core/modals/message/index";
import { CleansingType } from "../../../../../db/models/decontamination/index";
import OrderItemEditCleansingInstanceModal, { OrderItemEditCleansingInstanceModalData } from "../../modals/edit-cleansing-instance/index";
import { CleansingInstance } from "../../../../../db/models/decontamination/cleansingTypeusage";

export default class OrderItemCleansingTabView extends View
{
    public template = Template.lazy('/app/views/decontamination/orderItem/tab/cleansing/index.html');
    public app: FortumApp;
    private addCleansingInstanceButton: HTMLButtonElement;
    public data: OrderItemCleansingTabViewData;

    constructor(data?: OrderItemCleansingTabViewData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {        
        return super.afterRender();
    }

    private onEditButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {
        this.helpers.setButtonEnabled(sender, false);
        let itemId = parseInt(sender.getAttribute('data-item-id'));
        CleansingInstance.withAll(this.app.db, this.app.db.DeconCleansingInstance.where('id').equals(itemId)).then((instances) =>
        {
            this.openModal(OrderItemEditCleansingInstanceModal, sender, instances[0], {
                tab: 'cleansing'
            });
        });
    }

    private onAddButtonClick(e: MouseEvent, sender: HTMLButtonElement)
    {        
        let data = <OrderItemEditCleansingInstanceModalData>{
            item_id: this.data.item.id,
            id: null,
            isNew: true,
            usages: []
        };

        this.openModal(OrderItemEditCleansingInstanceModal, sender, data, {
            tab: 'cleansing'
        });
    }
}

export interface OrderItemCleansingTabViewData extends OrderItemDetailViewData
{
    availableCleansingTypes?: CleansingType[];
    availableCleansingTypeOptions?: SelectOptionData[];
    cleansingTypeToAdd?: SelectOptionData;
}